// extracted by css-extract-rspack-plugin
module.exports =  {"label":"FormGroup-m__label___G4laq","sublabel":"FormGroup-m__sublabel___t3eMj"};